import { SessionEndedNotice, type SessionEndedLabels } from '@ventawiz/web-kit'
import { useTranslation } from 'react-i18next'

/**
 * The web kit's "Your session ended" notice, in this app's words.
 *
 * Mounted once, in the root route. When a session ends mid-page — a refresh
 * refused, or a sign-out in another tab — the kit shows this for a moment and
 * then sends the browser to sign in with the current page as the return URL.
 * Without it mounted the kit navigates at once, with no word of why.
 */
export function SessionEnded() {
  const { t } = useTranslation()
  const labels: SessionEndedLabels = t('sessionEnded', { returnObjects: true })
  return <SessionEndedNotice labels={labels} />
}
